import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "sonner";

import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import About from "@/components/About";
import Akashic from "@/components/Akashic";
import Services from "@/components/Services";
import Sessions from "@/components/Sessions";
import Process from "@/components/Process";
import Testimonials from "@/components/Testimonials";
import Books from "@/components/Books";
import Meditations from "@/components/Meditations";
import FAQ from "@/components/FAQ";
import Contact from "@/components/Contact";
import InstagramBand from "@/components/InstagramBand";
import Footer from "@/components/Footer";
import { SignatureDivider } from "@/components/SignatureSymbol";

function App() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    const id = requestAnimationFrame(raf);
    window.__lenis = lenis;

    // anchor smooth scroll
    const handler = (e) => {
      const anchor = e.target.closest("a[href^='#'], [data-scroll-to]");
      if (!anchor) return;
      const target = anchor.getAttribute("href")?.slice(1) || anchor.getAttribute("data-scroll-to");
      if (!target) return;
      const el = document.getElementById(target);
      if (el) {
        e.preventDefault();
        lenis.scrollTo(el, { offset: -80 });
      }
    };
    document.addEventListener("click", handler);

    return () => {
      cancelAnimationFrame(id);
      document.removeEventListener("click", handler);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App relative overflow-x-hidden" data-testid="app-root">
      <Toaster position="top-center" richColors />
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <About />
        <Akashic />
        <Services />
        <Sessions />
        <Process />
        <SignatureDivider />
        <Testimonials />
        <Books />
        <SignatureDivider />
        <Meditations />
        <FAQ />
        <Contact />
      </main>
      <InstagramBand />
      <Footer />
    </div>
  );
}

export default App;
